import React, { useRef, useEffect, useState } from 'react'
import './styles/home-page.css'
import View from '../View/View.js'
import Customization from '../Customization/Customization.js'
import Navbar from '../Navbar/Navbar.js'
import { themes } from '../enums/enums.js'
import SearchBar from '../SearchBar/SearchBar.js'
import axios from 'axios';
import { v4 as uuidV4 } from 'uuid';

export default function HomePage() {
  const [listOfStationsToDisplayState, setListOfStationsToDisplayState] = useState([])
  const [customizationVisible, setCustomizationVisible] = useState(false);
  const [selectedTheme, setselectedTheme] = useState(null)
  const [isBus, setIsBus] = useState(false)
  const [routeBusStopsData, setRouteBusStopsData] = useState(null)

  useEffect(() => {
    const localStorageUserId = localStorage.getItem('UserId')
    if(localStorageUserId == null || localStorageUserId == undefined || localStorageUserId == '') {
      localStorage.setItem('UserId', uuidV4())
    }

    const localStorageTheme = localStorage.getItem('Theme')
    if(localStorageTheme == null || localStorageTheme == undefined) {
      localStorage.setItem('Theme', themes.ClassicLeftBound)
    }
    else{
      setselectedTheme(localStorageTheme)
    }

    const localStorageTrainStationsList = localStorage.getItem('BusAndTrainList');
    if(localStorageTrainStationsList && localStorageTrainStationsList.charAt(0) != '['){
      localStorage.setItem('BusAndTrainList', '')
    }
    if (localStorageTrainStationsList) {
      const stationStrings = localStorageTrainStationsList.split('&');
      const trainStationsListArray = stationStrings.map(stationString => {
        const cleanedString = stationString.slice(1, -1);
        const [index, isBus, busNumber, stopOrStationId, stopOrStationName, color, colorHex] = cleanedString.split(',');
        return {
          index: index,
          isBus: isBus,
          busNumber: busNumber,
          stopOrStationId: stopOrStationId,
          stopOrStationName: stopOrStationName,
          color: color,
          colorHex: colorHex
        };
      });

      setListOfStationsToDisplayState(trainStationsListArray);
    }
  }, []);

  function closeCustomizationModal(e) {
    if(e.target.id == 'customization-background' || e.target.id == 'customization-close-button'){
      setCustomizationVisible(false);
      setIsBus(false)
      document.body.style.position = '';
    }
  }

  async function openCustomizationModal() {
    setCustomizationVisible(true);
    document.body.style.position = 'fixed';

    // const response = await axios.get(process.env.REACT_APP_ENVIRONMENT + '/api/routes?search=h')
    // console.log(response)
  }

  async function clickedAddNewBusOrTrain(busNumber){
    let busStopsResponse
    try {
      if(busNumber){
        busStopsResponse = await axios.get(process.env.REACT_APP_ENVIRONMENT + '/api/route/stops?route=' + busNumber);
      }
      if (!busStopsResponse || !busStopsResponse.data) {
        console.error('no bus stops from search returned');
        return;
      }
    } catch (error) {
      console.error('Failed to fetch bus stops from search:', error);
      return;
    }

    setRouteBusStopsData(busStopsResponse.data)
    setIsBus(true)
    openCustomizationModal()
  }

  function clickedAddNewBusOrTrainWAIT(isBusParam, busNumberParam, stopNameParam, stopIdParam, colorParam, colorHexParam) {
    let localStorageTrainAndBusList = localStorage.getItem('BusAndTrainList');
    let trainAndBusListArray = [];
  
    if (localStorageTrainAndBusList) {
      const stationStrings = localStorageTrainAndBusList.split('&');
      trainAndBusListArray = stationStrings.map(stationString => {
        const cleanedString = stationString.slice(1, -1);
        const [index, isBus, busNumber, id/*, name, busOrtrainColor, hex*/] = cleanedString.split(',');
        return {
          index: index,
          isBus: isBus,
          busNumber: busNumber,
          stopId: id
          //stopName: name,
          //color: busOrtrainColor,
          //colorHex: hex
        };
      });
  
      // Check if the stop is already in the list
      const stopExists = trainAndBusListArray.some(stop => stop.stopId === stopIdParam && stop.color === colorParam);
      if (stopExists) {
        return; // stop already is in, so we do nothing
      }
    }
    const currentLengthOfList = trainAndBusListArray.length
  
    // Add the new stop to the array
    trainAndBusListArray.push({ currentLengthOfList, isBusParam, busNumberParam, stopIdParam, stopNameParam, colorParam, colorHexParam });
  
    // Convert the array back to the string format for localStorage
    localStorageTrainAndBusList = trainAndBusListArray
      .map(stop => `[${stop.index},${stop.isBus},${stop.busNumber},${stop.stopId},${stop.stopName},${stop.color},${stop.colorHex}]`)
      .join('&');
  
    // Update localStorage
    localStorage.setItem('BusAndTrainList', localStorageTrainAndBusList);
  
    // Update state
    // setListOfStationsToDisplayState(prevState => [
    //   ...prevState,
    //   { stationId, stationName, color: color, colorHex: colorHex }
    // ]);
  }

  function addTrainStationToList(stationName, stationId, color, colorHex) {
    let localStorageTrainStationsList = localStorage.getItem('BusAndTrainList');
    let trainStationsListArray = [];
  
    if (localStorageTrainStationsList) {
      const stationStrings = localStorageTrainStationsList.split('&');
      trainStationsListArray = stationStrings.map(stationString => {
        const cleanedString = stationString.slice(1, -1);
        const [index, isBus, busNumber, stopOrStationId, stopOrStationName, color, colorHex] = cleanedString.split(',');
        return {
          index: index,
          isBus: isBus,
          busNumber: busNumber,
          stopOrStationId: stopOrStationId,
          stopOrStationName: stopOrStationName,
          color: color,
          colorHex: colorHex
        };
      });
  
      // Check if the station is already in the list
      const stationExists = trainStationsListArray.some(station => station.stopOrStationId === stationId && station.color === color);
      if (stationExists) {
        return; // Station already is in, so we do nothing
      }
    }
  
    // Add the new station to the array
    const index = trainStationsListArray.length
    const isBus = false
    const busNumber = ''
    trainStationsListArray.push({ index: index, isBus: isBus, busNumber: busNumber, stopOrStationId: stationId, stopOrStationName: stationName, color: color, colorHex: colorHex });
  
    // Convert the array back to the string format for localStorage
    localStorageTrainStationsList = trainStationsListArray
      .map(entry => `[${entry.index},${entry.isBus},${entry.busNumber},${entry.stopOrStationId},${entry.stopOrStationName},${entry.color},${entry.colorHex}]`)
      .join('&');
  
    // Update localStorage
    localStorage.setItem('BusAndTrainList', localStorageTrainStationsList);
  
    // Update state
    setListOfStationsToDisplayState(trainStationsListArray)
  }

  function removeStationClick(stopId, color) {
    let localStorageBusAndTrainList = localStorage.getItem('BusAndTrainList');
    if (!localStorageBusAndTrainList) {
      return; // Nothing to remove if the list is empty
    }
  
    // Parse the list from localStorage
    const stationStrings = localStorageBusAndTrainList.split('&');
    let busAndTrainListArray = stationStrings.map(stationString => {
      const cleanedString = stationString.slice(1, -1); // Remove the brackets
      const [index, isBus, busNumber, id, name, busOrtrainColor, hex] = cleanedString.split(',');
        return {
          index: index,
          isBus: isBus,
          busNumber: busNumber,
          stopOrStationId: id,
          stopOrStationName: name,
          color: busOrtrainColor,
          colorHex: hex
        };
    });
  
    // Filter out the station to remove
    //console.log(color, busAndTrainListArray[1].color)
    busAndTrainListArray = busAndTrainListArray.filter(stop => (stop.stopOrStationId !== stopId || stop.color !== color));
  
    // Convert the array back to the string format for localStorage
    localStorageBusAndTrainList = busAndTrainListArray
    .map(entry => `[${entry.index},${entry.isBus},${entry.busNumber},${entry.stopOrStationId},${entry.stopOrStationName},${entry.color},${entry.colorHex}]`)
    .join('&');
  
    // Update localStorage
    localStorage.setItem('BusAndTrainList', localStorageBusAndTrainList);
  
    // Optionally update state if you are maintaining the list in a state variable
    setListOfStationsToDisplayState(busAndTrainListArray);
  }

  function clickedThemeChoice(selectedTheme) {
    localStorage.setItem('Theme', selectedTheme)
    setselectedTheme(selectedTheme)
  }

  return (
    <div className='home-page-container'>
      <Navbar openCustomizationModal={openCustomizationModal} clickedAddNewBusOrTrain={clickedAddNewBusOrTrain} />
      <View listOfStationsToDisplay={listOfStationsToDisplayState} selectedTheme={selectedTheme}/>
      {customizationVisible && (
        <Customization
          listOfStationsToDisplay={listOfStationsToDisplayState}
          closeCustomizationModal={closeCustomizationModal}
          addTrainStationToList={addTrainStationToList}
          removeStationClick={removeStationClick}
          clickedThemeChoice={clickedThemeChoice}
          isBus={isBus}
          routeBusStopsData={routeBusStopsData}
        />
      )}
    </div>
  )
}
